import { render, staticRenderFns } from "./checkCourse.vue?vue&type=template&id=23c31709&"
import script from "./checkCourse.vue?vue&type=script&lang=js&"
export * from "./checkCourse.vue?vue&type=script&lang=js&"
import style0 from "./checkCourse.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports